"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EDocumentValidationStatus = void 0;
exports.EDocumentValidationStatus = {
    pending: "pending",
    validated: "validated",
    anomalyReported: "anomalyReported",
};
